import React from "react";
import { cn } from "@/lib/utils";

/**
 * The single source of truth for section content width and horizontal
 * padding across the entire site. Every page section's content flows
 * through this component — no component may declare its own max-width or
 * horizontal padding for section-level content.
 *
 * Reading-measure limits (max-w-prose, max-w-2xl, the 720px legal column)
 * belong on child elements INSIDE the container, never on the container.
 */
export default function Container({ className, children, ...props }) {
  return (
    <div className={cn("w-full max-w-[1240px] mx-auto px-4 sm:px-6 lg:px-8", className)} {...props}>
      {children}
    </div>
  );
}